import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-mouse",
  templateUrl: "./med-icon-mouse.component.html",
})
export class MedIconMouseComponent extends SvgMixinComponent {}
